import {Suspense } from "react";
import { helix } from "ldrs";
import { useAuth } from "components/auth/AuthContext";
import RouteIndex from "routes/RouteIndex";



function App() {
  const { isAuthLoading } = useAuth();
  helix.register();

  if (isAuthLoading) {
    return (
      <div className="center__loader container">
        <l-helix size="80" speed="2.5" color="#B19CD7"></l-helix>
      </div>
    );
  }

  return (
    <Suspense
      fallback={
        <div className="center__loader container">
          <l-helix size="80" speed="2.5" color="#B19CD7"></l-helix>
        </div>
      }
    >
      <RouteIndex />
    </Suspense>
  );
}

export default App;
